export const PollResultPercentage = ({ totalVotes, votes }: { totalVotes: number; votes: number }) => (
    <span data-testid="pollResultPercentage">{getPercentage(votes!, totalVotes!)}%</span>
);

const getPercentage = (votes: number, totalVotes: number) => {
    const percentage = totalVotes > 0 ? (votes / totalVotes) * 100 : 0;
    return Math.round(percentage);
};
